import { Filter } from 'app/modules/filters/models';

import { getDefaultAiAgentFilters } from 'app/modules/aiAgents/filters';
import { LocalStorageKeys } from 'app/shared/constants/localStorage';

import { u21CreateAsyncThunk } from 'app/shared/thunk/u21CreateAsyncThunk';
import { u21CreateSlice } from 'app/shared/thunk/u21CreateSlice';

export const AI_AGENTS_SLICE_NAME = 'aiAgents';

interface AiAgentsState {
  filters: Filter[];
}

const initialState: AiAgentsState = {
  filters: getDefaultAiAgentFilters(),
};

export const setAiAgentFilters = u21CreateAsyncThunk<Filter[], Filter[]>(
  `${AI_AGENTS_SLICE_NAME}/SET_AI_AGENT_FILTERS`,
  (payload) => {
    localStorage.setItem(
      LocalStorageKeys.AI_AGENTS_FILTERS,
      JSON.stringify(payload),
    );
    return payload;
  },
);

export const aiAgentsSlice = u21CreateSlice({
  initialState,
  name: AI_AGENTS_SLICE_NAME,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setAiAgentFilters.fulfilled, (draft, action) => {
      draft.filters = action.payload;
    });
  },
});

export const aiAgentsReducer = aiAgentsSlice.reducer;
